import { Navigate, useParams } from 'react-router-dom';
import routes from 'constants/routes';

/** Legacy wallet invoice URL → canonical /payment-requests/:id (email link target). */
export default function WalletInvoiceDetailRedirect() {
    const { id = '' } = useParams();
    if (!id) return <Navigate to={routes.home.main} replace />;
    return <Navigate to={routes.paymentRequests.detail.replace(':id', id)} replace />;
}
